"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Zoom = exports.Navigation = exports.ImgIndexer = exports.ImageViewer = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _CwImageViewer = _interopRequireDefault(require("./CwImageViewer.scss"));

var _IconPath = _interopRequireDefault(require("../../utils/IconPath"));

var _CwButton = _interopRequireDefault(require("../../components/cwbutton/CwButton"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var ZoomRanges = [25, 33, 60, 67, 75, 80, 100, 110, 125, 150, 175, 200, 250, 300, 400, 500];
/**
 * Base Image Viewer with entry for zoom, scales img based on window height
 */

var ImageViewer =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(ImageViewer, _React$PureComponent);

  function ImageViewer(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ImageViewer);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ImageViewer).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onLoad", function (_ref) {
      var img = _ref.target;

      if (img.offsetHeight > window.innnerHeight || img.offsetWidth > window.innerWidth) {
        _this.setState({
          scaleDiv: true,
          loaded: true
        });
      } else {
        _this.setState({
          scaleDiv: false,
          loaded: true
        });
      }
    });
    _this.state = {
      scaleDiv: false,
      loaded: false
    };
    return _this;
  }

  (0, _createClass2.default)(ImageViewer, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.image !== prevProps.image) {
        this.setState({
          loaded: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var size = this.props.zoomPercent / 100;
      return _react.default.createElement("div", {
        className: _CwImageViewer.default.enlargedBackground
      }, _react.default.createElement("div", {
        className: _CwImageViewer.default.fill
      }, _react.default.createElement("img", {
        alt: "imgEnlarged",
        onLoad: this.onLoad,
        className: _CwImageViewer.default.imgEnlarge,
        src: this.props.image,
        height: this.state.scaleDiv ? '100%' : null,
        style: {
          transform: "scale(".concat(size, ")"),
          visibility: this.state.loaded ? 'visible' : 'hidden'
        }
      })));
    }
  }]);
  return ImageViewer;
}(_react.default.PureComponent);

exports.ImageViewer = ImageViewer;
(0, _defineProperty2.default)(ImageViewer, "defaultProps", {
  zoomPercent: 100
});
;
ImageViewer.propTypes = {
  /**
   * image being rendered
   */
  image: _propTypes.default.string.isRequired,

  /**
   * entry to control image's zoom
   */
  zoomPercent: _propTypes.default.number
};
/**
 * HOC for multiple images
 */

var ImgIndexer = function ImgIndexer(WrappedComponent) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_React$Component) {
    (0, _inherits2.default)(ImgIndexerHoc, _React$Component);

    function ImgIndexerHoc(props) {
      var _this2;

      (0, _classCallCheck2.default)(this, ImgIndexerHoc);
      _this2 = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ImgIndexerHoc).call(this, props));
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "onPrevClick", function () {
        if (_this2.state.currentIndex !== 0) {
          _this2.setState(function (prevState) {
            prevState.currentIndex -= 1;
            return prevState;
          }, function () {
            return _this2.props.onImgIndexUpdated(_this2.state.currentIndex);
          });
        }
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "onNextClick", function () {
        if (_this2.state.currentIndex !== _this2.props.images.length - 1) {
          _this2.setState(function (prevState) {
            prevState.currentIndex += 1;
            return prevState;
          }, function () {
            return _this2.props.onImgIndexUpdated(_this2.state.currentIndex);
          });
        }
      });
      _this2.state = {
        currentIndex: _this2.props.imgIndex
      };
      return _this2;
    }

    (0, _createClass2.default)(ImgIndexerHoc, [{
      key: "render",
      value: function render() {
        return _react.default.createElement(WrappedComponent, (0, _extends2.default)({}, this.props, {
          currentIndex: this.state.currentIndex,
          image: this.props.images[this.state.currentIndex],
          onPrevClick: this.onPrevClick,
          onNextClick: this.onNextClick
        }));
      }
    }]);
    return ImgIndexerHoc;
  }(_react.default.Component), (0, _defineProperty2.default)(_class, "defaultProps", {
    imgIndex: 0,
    onImgIndexUpdated: function onImgIndexUpdated() {}
  }), _temp;
};

exports.ImgIndexer = ImgIndexer;
ImgIndexer.propTypes = {
  /**
   * array of image locations
   */
  images: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,

  /**
   * starting img viewed, defaults to 0
   */
  imgIndex: _propTypes.default.number,

  /**
   * callback on when image index is updated
   */
  onImgIndexUpdated: _propTypes.default.func
};
/**
 * Navigation HOC, doesn't have functionality other than triggering callbacks
 */

var Navigation = function Navigation(WrappedComponent) {
  return function (props) {
    return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(WrappedComponent, props), _react.default.createElement("div", {
      className: _CwImageViewer.default.imgCounter
    }, _react.default.createElement("div", {
      style: {
        fontSize: '0.5em'
      }
    }, props.currentIndex + 1 + '/' + props.images.length)), _react.default.createElement("div", {
      className: _CwImageViewer.default.nav
    }, props.onDownload && _react.default.createElement(_CwButton.default, {
      isStandard: false,
      automationName: 'img-viewer-dl-img',
      className: _CwImageViewer.default.btns,
      onClick: props.onDownload,
      icon: _IconPath.default.get('Action_Download')
    }), _react.default.createElement(_CwButton.default, {
      isStandard: false,
      automationName: 'img-viewer-close-img',
      className: _CwImageViewer.default.btns,
      onClick: props.onClose,
      icon: _IconPath.default.get('Action_Close')
    })), props.onPrevClick && _react.default.createElement("div", {
      className: _CwImageViewer.default.navLeft
    }, _react.default.createElement(_CwButton.default, {
      isStandard: false,
      automationName: 'img-viewer-back-img',
      className: _CwImageViewer.default.btns,
      onClick: function onClick() {
        props.onPrevClick();
        props.resetZoom();
      },
      icon: _IconPath.default.get('Action_Back')
    })), props.onNextClick && _react.default.createElement("div", {
      className: _CwImageViewer.default.navRight
    }, _react.default.createElement(_CwButton.default, {
      isStandard: false,
      automationName: 'img-viewer-fwd-img',
      className: _CwImageViewer.default.btns,
      onClick: function onClick() {
        props.onNextClick();
        props.resetZoom();
      },
      icon: _IconPath.default.get('Action_Forward')
    })));
  };
};

exports.Navigation = Navigation;
Navigation.propTypes = {
  /**
   * current index of image
   */
  currentIndex: _propTypes.default.number.isRequired,

  /**
   * download button callback
   */
  onDownload: _propTypes.default.func,

  /**
   * close button callback
   */
  onClose: _propTypes.default.func.isRequired,

  /**
   * prev img button callback
   */
  onPrevClick: _propTypes.default.func,

  /**
   * next img button callback
   */
  onNextClick: _propTypes.default.func,

  /**
   * reset zoom of img when navigating
   */
  resetZoom: _propTypes.default.func
};
Navigation.defaultProps = {
  resetZoom: function resetZoom() {}
};
/**
 * Zoom Hoc
 */

var Zoom = function Zoom(WrappedComponent) {
  var _temp2;

  return _temp2 =
  /*#__PURE__*/
  function (_React$Component2) {
    (0, _inherits2.default)(ZoomHoc, _React$Component2);

    function ZoomHoc(props) {
      var _this3;

      (0, _classCallCheck2.default)(this, ZoomHoc);
      _this3 = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ZoomHoc).call(this, props));
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this3), "onZoomIn", function () {
        if (_this3.state.currentZoomIndex !== ZoomRanges.length - 1) {
          _this3.setState(function (prevState) {
            prevState.currentZoomIndex += 1;
            return prevState;
          });
        }
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this3), "onZoomOut", function () {
        if (_this3.state.currentZoomIndex !== 0) {
          _this3.setState(function (prevState) {
            prevState.currentZoomIndex -= 1;
            return prevState;
          });
        }
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this3), "resetZoom", function () {
        _this3.setState({
          currentZoomIndex: 6
        });
      });
      _this3.state = {
        currentZoomIndex: 6
      };
      return _this3;
    }

    (0, _createClass2.default)(ZoomHoc, [{
      key: "render",
      value: function render() {
        return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(WrappedComponent, (0, _extends2.default)({}, this.props, {
          zoomPercent: ZoomRanges[this.state.currentZoomIndex],
          resetZoom: this.resetZoom
        })), _react.default.createElement("div", {
          className: _CwImageViewer.default.zoomWrap
        }, _react.default.createElement("div", {
          className: _CwImageViewer.default.zoom
        }, _react.default.createElement(_CwButton.default, {
          isStandard: false,
          automationName: 'img-viewer-zoom-out-img',
          className: _CwImageViewer.default.btns,
          onClick: this.onZoomOut,
          icon: _IconPath.default.get('Action_ZoomOut')
        }), _react.default.createElement("div", {
          style: {
            fontSize: '0.5em'
          }
        }, ZoomRanges[this.state.currentZoomIndex] + '%'), _react.default.createElement(_CwButton.default, {
          isStandard: false,
          automationName: 'img-viewer-zoom-in-img',
          className: _CwImageViewer.default.btns,
          onClick: this.onZoomIn,
          icon: _IconPath.default.get('Action_ZoomIn')
        }))));
      }
    }]);
    return ZoomHoc;
  }(_react.default.Component), _temp2;
};

exports.Zoom = Zoom;
var ImageViewerNavZoom = Zoom(ImgIndexer(Navigation(ImageViewer)));
var _default = ImageViewerNavZoom;
exports.default = _default;